import Vue from 'vue'
import merge from 'lodash/merge'
const axios = Vue.axios

const DRIVE_BASE = '//drive.wps.cn'
const PLUS_BASE = '//plus.wps.cn/app/media/api'
const ACCOUNT_BASE = '//account.wps.cn'
const KDOCS_BASE = '//www.kdocs.cn'
const PLUSSVR_BASE = '//plussvr.wps.cn'
const API_BASE = '//api.wps.cn'

export function getUserInfo () {
  return axios.post(`${ACCOUNT_BASE}/p/auth/check`)
}

export function logout () {
  return axios.post(`${ACCOUNT_BASE}/p/logout`)
}

export function GetFileInfoBySid (sid) {
  let params = {
    review: true
  }
  return axios.get(`${DRIVE_BASE}/api/v5/links/${sid}`, { params }).then(data => merge(data, { fileinfo: { fileid: data.fileinfo.id } }))
}

export function GetFileInfoByFileId (fileId) {
  return axios.get(`${DRIVE_BASE}/api/v5/files/${fileId}/metadata`, { params: { from: 'preview', review: true, with_link: true } })
}

export function GetMediaPreview (groupId, fileId, type = 'normal') {
  let params = { preview_style: type }
  return axios.get(`${API_BASE}/office/v5/extensions/preview/groups/${groupId}/files/${fileId}/media/preview`, { params })
}

export function download (groupId, fileId) {
  return axios.get(`${DRIVE_BASE}/api/v3/groups/${groupId}/files/${fileId}/download`, { params: { isblocks: false } })
}

export function downloadBySid (sid) {
  return axios.get(`${DRIVE_BASE}/api/v3/links/${sid}/download`)
}

export function checkPrivilege (groupId, type = 'normal') {
  let params = {
    preview_style: type,
    group_id: groupId
  }
  return axios.get(`${API_BASE}/office/v5/extensions/preview/privilege/check`, { params })
}

export function appeal (sid) {
  return axios.post(`${DRIVE_BASE}/api/v3/links/${sid}/appeal`)
}
// 获取指定的文件标签
export function getStarStatus (fid) {
  let params = { fileids: fid }
  return axios.get(`${DRIVE_BASE}/api/v3/tags/1/files`, { params })
}
// 对目标对象 (文档/圈子) 打标签
export function setStar (params) {
  return axios.post(`${DRIVE_BASE}/api/v3/tags/1/items`, params)
}
// 删除指定的标签对象 (文件/圈子)
export function deleteStar (fid) {
  return axios.delete(`${DRIVE_BASE}/api/v3/tags/1/files/${fid}`)
}
// 获取文件的路径信息
export function getFilePath (gid, fid) {
  return axios.get(`${DRIVE_BASE}/api/v3/groups/${gid}/files/${fid}/path`)
}
// 文件重命名
export function onRename ({ gid, fid, fname }) {
  return axios.put(`${DRIVE_BASE}/api/v3/groups/${gid}/files/${fid}`, { fname })
}
// 文件申诉状态查询
export function getAppealStatus (fid) {
  return axios.get(`${KDOCS_BASE}/api/kdocs/file/${fid}/appeal/status`)
}
// 文件封禁申诉
export function appealByFid (fid, params) {
  return axios.post(`${KDOCS_BASE}/api/kdocs/fcheck/${fid}/appeal`, params)
}
// 获取企业用户信息
export function getUserSelf (cid) {
  return axios.get(`${PLUSSVR_BASE}/svr/v1/companies/${cid}/users/self`)
}
// 获取企业服务信息
export function getCompanyService (cid) {
  return axios.get(`${PLUSSVR_BASE}/compose/v1/u/companies/batch/service-space?comp_ids=${cid}&fields=comp_auth`)
}
// 获取当前团队信息
export async function getGroupInfo (groupId) {
  return axios.get(`${DRIVE_BASE}/api/v3/groups/${groupId}`)
}

// 查询审核申诉状态
export function getAppeal (fid) {
  return axios.get(`${API_BASE}/office/v5/extensions/preview/files/${fid}/media/audit/status`)
}

// 提交申诉
export function postAppeal (fid,params = {warning_type: 3}) {
  return axios.post(`${PLUS_BASE}/v1/u/files/${fid}/media/warn`, params)
}


/**
 * 获取link info
 * @param {string|number} fid
 * @returns {Promise<{link_id: string, link_url: string, group_id:number, file_id: number}|{}>}
 */
export async function getLinkInfoByFid (fid) {
  const data = await axios.get(`/api/v5/links/batch/query?file_ids=${fid}`, { baseURL: DRIVE_BASE })
  return data.link_list[0] || {}
}

/**
 * https://cloud-doc.wps.cn/qing_v1/roamingfiles.html#post-apiroaminginfos
 * 添加漫游记录
 * @param {fileid?:number, groupid?:number, parent?:number, size:number, name: string, status:string, operation: 'open'|'create'|'save', app_type: string, current_device_id: string,current_device_type:string, current_device_name: string } data
 * @returns {Promise<*>}
 */
export async function addRoamingInfos (data) {
  return axios.post('/api/roaminginfos', data, {
    baseURL: DRIVE_BASE
  })
}

// 获取微信签名
export async function getWxSDKSignature (url) {
  return axios.get('/kfc/account/v1/wechat/jsapi/signature', {
    baseURL: KDOCS_BASE,
    params: {
      t: +new Date(),
      url: encodeURIComponent(url)
    }
  })
}
